import React, { useState } from "react";
import Popup from "../components/Popup";
import { images } from "../shared/images";

const Whitelist = () => {
	const [openPopup, setOpenPopup] = useState(false);

	const isInWinningList = false;

	const tableWhitelistHeads = ["Date", "Amount", "Transaction#"];

	const tableWhitelistData = [
		{
			id: 1,
			date: "10-2-2023",
			amount: "0.01",
			trx_hash: "0x2fg3ghh52a4s560x2fg3ghh52a4s56",
		},
		{
			id: 2,
			date: "10-2-2023",
			amount: "0.01",
			trx_hash: "0x2fg3ghh52a4s560x2fg3ghh52a4s56",
		},
		{
			id: 3,
			date: "10-2-2023",
			amount: "0.01",
			trx_hash: "0x2fg3ghh52a4s560x2fg3ghh52a4s56",
		},
	];

	return (
		<div className="whitelist-page">
			<div className="whitelist-page__banner">
				<picture>
					<source media="(min-width:650px)" srcSet={images.whitelistBanner} />
					<source
						media="(min-width:465px)"
						srcSet={images.whitelistBannerMobile}
					/>
					<img src={images.whitelistBannerMobile} alt="Banner" />
				</picture>
				{/* <img src={images.whitelistBanner} alt="Banner" /> */}
			</div>
			<div className="whitelist-page__text">
				<h1 className="heading">Whitelist Spot Allocation</h1>

				<p className="para">Welcome to the Nitro BoT Army Whitelist Check!</p>
				<p className="para">Best of luck and thanks for your support!</p>

				<p className="para">
					We are excited to announce the launch of Nitro BoT Army NFT. <br></br>{" "}
					Thank you for participating in our Whitelist. Enter your wallet
					address to see if you secured a spot.
				</p>

				<p className="para">
					Our team carefully considered all applicants, and we're confident
					Nitro BoT Army will revolutionize the NFT world.
				</p>

				<div className="input-over">
					<form className="input">
						<input
							className=""
							type="text"
							name="wallet-address"
							id="wallet-address"
							placeholder="0x57986538954d986fd5sg85f2s9e68f"
						/>
						<button
							onClick={(e) => {
								e.preventDefault();
								setOpenPopup(true);
							}}
							className=""
							type="submit"
						>
							Check
						</button>
					</form>
				</div>
			</div>

			{/* <!---- Visible only in winning  ----> */}
			<div className="whitelist-page__winning">
				<p className="para text-center">
					Congratulations on winning a Whitelist (WL) spot! To claim your WL
					NFT, please follow these steps:
				</p>

				<ul>
					<li>Connect your wallet.</li>
					<li>Check your information for the WL Spots you have won.</li>
					<li>Proceed to pay to claim your NFT.</li>
				</ul>

				<p>
					<small>
						Please note: The WL spot you have won will be available to you until
						22 Feb, 11:30 PM UTC. If you fail to pay, you will lose your spot.{" "}
						<br />
						For more information,{" "}
						<a href="/faq" className="text-underline text-white">
							read our FAQ section.
						</a>
					</small>
				</p>

				<div className="text-center connect-wallet">
					<button className="btn btn-pink">Connect Wallet</button>
				</div>

				<div className="four-boxes">
					<div className="box">
						<p>You Paid</p>
						<h3>0.01 ETH</h3>
					</div>
					<div className="box">
						<p>NFT Quantity</p>
						<h3>1</h3>
					</div>
					<div className="box">
						<p>Pending Amount</p>
						<h3>0.04 ETH</h3>
					</div>
					<div className="box grid-center">
						<button className="btn btn-pink">Pay Now</button>
					</div>
				</div>

				<div className="whitelist-page__winning--table">
					<h2 className="text-center">Transactions</h2>

					<table className="">
						<thead>
							<tr>
								{tableWhitelistHeads.map((data, i) => {
									return (
										<th key={i} scope="col" className="right">
											{data}
										</th>
									);
								})}
							</tr>
						</thead>
						<tbody>
							{tableWhitelistData.map((data, i) => {
								return (
									<tr key={i}>
										<td
											className="text-left"
											data-label={tableWhitelistHeads[0]}
										>
											{data.date}
										</td>
										<td
											className=" right overflow-text"
											data-label={tableWhitelistHeads[1]}
										>
											<span className="trx-id">{data.amount}</span>
										</td>
										<td
											className="right max-width"
											data-label={tableWhitelistHeads[2]}
										>
											<span className="trx-hash">{data.trx_hash}</span>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			</div>

			{openPopup && (
				<Popup setOpenPopup={setOpenPopup}>
					{isInWinningList ? (
						<div>
							<p className="text-center">
								Hurray!😁 <br />
								You have got the whitelist Spot! <br /> Click Next to Proceed☺
							</p>
							<div className="text-center">
								<button className="btn btn-pink">Next</button>
							</div>
						</div>
					) : (
						<div>
							<p className="text-center">
								Sorry! You didn't get a Whitelist spot😫. <br /> But don't
								worry, you can get one once it's up for public sale on OpenSea
								on 28th. Thanks for participating. Stay tuned!
							</p>
							<div className="text-center">
								<button
									className="btn btn-pink btn-transparent"
									onClick={() => setOpenPopup(false)}
								>
									Close
								</button>
							</div>
						</div>
					)}
				</Popup>
			)}
		</div>
	);
};

export default Whitelist;
